import { APP_LOCALES } from 'locale/locale.config';

const content = {
  [APP_LOCALES.IE]: {
    locatePharmacyBtnText: 'Locate a pharmacy',
  },
  [APP_LOCALES.UK]: {
    locatePharmacyBtnText: 'Locate a pharmacy',
  },
  [APP_LOCALES.NHS]: {
    locatePharmacyBtnText: 'Locate a pharmacy',
  },
  [APP_LOCALES.NHS_FIRST]: {
    locatePharmacyBtnText: 'Locate a store',
  },
};

export default content;
